/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import { _helpers } from '../../../lib/ProjectReportValidation';
import {  GroupedProjectNameAndEndDate, TKickbackReportById } from '../../../services/API/Kickback';
import { EditableFields, FieldChangeHandler, Status, EditableFieldsOnRows, EditableFieldsOnReport, FieldChangeContext } from './editkickbacktypes';


  const fieldHandlers: Record<EditableFields, FieldChangeHandler> = {
    comment:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
        const currState = structuredClone(report);
        const buff = currState['contracts'][fieldId];
        buff['comment'] = newValue.target.value;
        
        return currState;
    },
    commentKickbackChange:(prop,report,fieldId,newValue,context/*value,field,fields,fieldId,context*/) => {
        const currState = structuredClone(report);
        const buff = currState['contracts'][fieldId];
        buff['commentKickbackChange'] = newValue.target.value;
        return currState;
        //return currState;
    },
    projectName: (prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/) => {
        const currState = structuredClone(report);
        const buff = currState['contracts'][fieldId];
        if('text' in context && context.text){
            buff['projectName'] = newValue[0];
            return currState; 
        }
        else if('text' in context && 'projectNamesAndDates'  in context && 'source' in context && 'setter' in context && !context.text){
            buff['projectName'] = newValue[0];
            buff['projectEndDate'] = typeof context.projectNamesAndDates[buff.contractId][newValue[0]] == 'undefined' ? '':context.projectNamesAndDates[buff.contractId][newValue[0]] as string;
            
            const exists = context.source.filter(x => x == newValue[0]);
                if(exists.length == 0){
                   const currOptions = structuredClone(context.source);
                   currOptions.push(newValue[0]);
                    context.setter(currOptions);
                }
            return currState; 
        }
    return report;
    },
    contractId:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
        const currState = structuredClone(report);
        if(context.type !== 'contractId'){
            return report
        }if('text' in context && 'contracts' in context && 'projectNamesAndDates'  in context){
            const buff = currState['contracts'][fieldId];
          const selected = newValue[0].replace(' ','').split('-');
          
                const  {contractId} = {contractId:context.text ? '':selected[0].trim()};
                buff['contractId'] = context.text ? '':  contractId == undefined ? '' : contractId;
                buff['name'] = context.text ? '': context.contracts[contractId].name == undefined ? '':context.contracts[contractId].name;
                buff['kickbackProcent'] = context.text ? 0: context.contracts[contractId].kickbackPercent == undefined ? 0:+(_helpers.convertToPercentage(context.contracts[contractId].kickbackPercent)* 100).toFixed(2);
                buff['type'] = context.text ? '': context.contracts[contractId].title == undefined ? '':context.contracts[contractId].title;
                buff['projectEndDate'] = (buff['projectName'] == null || typeof context.projectNamesAndDates[contractId] == 'undefined') ? '':  context.projectNamesAndDates[contractId][buff['projectName']] as string
            
                return currState;
        }
        return report;
    },
    projectEndDate:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
       
        if('setter' in context && 'projectNamesAndDates' in context && context.type == 'projectEndDate'){
            const currState = structuredClone(report) as TKickbackReportById;
            const currStateProjectEndDates = structuredClone(context.projectNamesAndDates) as GroupedProjectNameAndEndDate;
            const {contractId,projectName} = currState['contracts'][fieldId];
            currStateProjectEndDates[contractId][projectName as string] = newValue?.toLocaleDateString('sv-SE') ?? "";
            
            const rowsAffected = currState['contracts'].filter(report => {
                if(report.contractId == contractId && report.projectName == projectName){
                    return report;
                }
            });
            rowsAffected.map(row => {
                return row.projectEndDate = newValue?.toLocaleDateString('sv-SE') ?? "";
            })
            
            //filtrera ut de rader som kommer att påverkas med hjälv av projectName och contractId, sätt nytt värde på dom
            //uppdatera projectNamesAndDates med nyckeln contractId och projectName
            
            context.setter(currStateProjectEndDates);
            //setterFunction(currStateProjectEndDates);
            return currState;
            
        }
        else{
            return report;
        }
       
    },
    invoicedSum:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
        console.log(prop)
        return report;
    },
    reportedSum:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
        const currState = structuredClone(report);
        const buff = currState['contracts'][fieldId];
        buff['reportedSum'] = +newValue.target.value;
        return currState;
       
        
    },
    invoiceIdentifier:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
        const currState = structuredClone(report);
        const buff = currState['contracts'][fieldId];
        if('text' in context && 'setter' in context && 'source' in context){
            if(context.text){
                buff.invoiceIdentifier = newValue[0]
                return currState;
            }else{
                buff.invoiceIdentifier = newValue[0];
                const exists = context.source.filter(x => x == newValue[0]);
                if(exists.length == 0){
                   const currOptions = structuredClone(context.source);
                   currOptions.push(newValue[0]);
                   context.setter(currOptions);
                }
                return currState;
            }
        }
        return report;
    },
    invoiceReference:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/)=> {
        const currState = structuredClone(report);
        const buff = currState['contracts'][fieldId];
        if('text' in context && 'setter' in context && 'source' in context){
            if(context.text){
                buff.invoiceReference = newValue[0];
                return currState;
            }else{
                buff.invoiceReference = newValue[0];
                const exists = context.source.filter(x => x == newValue[0]);
                if(exists.length == 0){
                   const currOptions = structuredClone(context.source);
                   currOptions.push(newValue[0]);
                   context.setter(currOptions);
                }
                return currState;
            }
        }
        return report;
    },
    department:(prop,report,fieldId,newValue,context/*value, field, fields,fieldId,context*/) => {
        let updatedReport = structuredClone(report) as TKickbackReportById;
    if (updatedReport?.department?.id !== newValue.id && typeof updatedReport !== 'undefined') {
      updatedReport = {...updatedReport,department:newValue}
      return updatedReport;
    }
    else{
        return report;
    }
    },
    status:(prop,report,fieldId,newValue,context) => {
        const value:Status = newValue as Status;
        let currState = structuredClone(report);
        currState = {...currState,status:value.key};
        return currState;
    }
  };
  const isContractField = (prop: EditableFields): prop is EditableFieldsOnRows =>
    [
      "comment",
      "commentKickbackChange",
      "contractId",
      "projectName",
      "projectEndDate",
      "invoicedSum",
      "reportedSum",
      "invoiceIdentifier",
      "invoiceReference",
    ].includes(prop);
  
  const isReportField = (prop: EditableFields): prop is EditableFieldsOnReport =>
    ["status", "department"].includes(prop);
  export const handleFieldChange = (
    prop: EditableFields,
    report: TKickbackReportById,
    fieldId: number,
    newValue: any,
    context:FieldChangeContext
  ): TKickbackReportById => {
    
    if(isReportField(prop)){
        const handler = fieldHandlers[prop] as FieldChangeHandler;
        return handler(prop, report, fieldId,newValue,context);
    }
    else if(isContractField(prop)){
        const handler = fieldHandlers[prop] as FieldChangeHandler;
        return handler(prop, report, fieldId,newValue,context);
    }
    else{
        return report;
    }
  };